import { render, staticRenderFns } from "./PsychotechnicFiles.vue?vue&type=template&id=cb0da6c4&"
import script from "./PsychotechnicFiles.vue?vue&type=script&lang=js&"
export * from "./PsychotechnicFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports